import React, { useState, useEffect, useRef } from "react";

import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { Minus } from "lucide-react";
import { Plus } from "lucide-react";
import { Button } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./EventProductPage.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastsuccess, gettoastwarning } from '../../Utils/Common';
import { validatemember, validatequestion, validatejoinwaitlist, validatecheckeventpassword } from '../../Utils/validate';
import { X } from "lucide-react";
import { v4 as uuidv4 } from 'uuid';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const EventProductPage = () => {

	const [showbook, setShowbook] = useState(false);

	const [showdetails, setShowdetails] = useState(true);

	const [inputsb, setInputsb] = useState({ password: ''});

	const sliderRef = useRef(null);

	const settings = {
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
	};

	const navigate = useNavigate();
	const { id } = useParams()

	const [errors, setErrors] = useState({});

	const [inputs, setInputs] = useState({ event_id: '', event_title: '', category_name: '', location_name: '', event_address: '', event_image: '', event_header_image: '', desktop_image: '', date: '', day: '', month: '', event_date: '', event_start_time: '', event_end_time: '', short_description: '', about_event: '', tickets_type: '', tickets_price: 0, total_tickets: 0, vat_percentage: 0, sub_total: 0, total_fees: 0, total_vat: 0, grand_total: 0, age_start: '', age_end: '',is_event_waitlist:0,tax_type:'',symbol:'',currency:'',is_free_event:0});
	const [gallery, setGallery] = useState([]);
	const [agenda, setAgenda] = useState([]);
	const [ticket, setTicket] = useState([]);
	const [loading, setLoading] = useState(true);
	const [member, setMember] = useState([]);
	const [question, setQuestion] = useState([]);
	const [tags, setTags] = useState([]);

	const [inputsj, setInputsj] = useState({ first_name: '', last_name: '', email: '', phone_number: '',age:'',gender:'' });

	const [showFirst, setShowFirst] = useState(false);

	const [showTwo, setShowTwo] = useState(false);

	const [showThree, setShowThree] = useState(false);

	const handleShowDirectLeavePopup = () => {
		setShowThree(true); // Open the modal
	};

	const LeaveUrlDirect = () => {
		const eventId = inputs.event_id;
		window.location.href = `/event-product/${eventId}`;
	};

	const handleIncrease = (event, ticket_id) => {
		const updatedTicket = ticket.map((val) => {
			if (val.id === ticket_id) {
				if (val.qty < 5) {
					if (val.qty < val.total_tickets) {
						var q = val.qty + 1;

						var price = val.booking_price;
						if (q > 0) {
							price = q * val.booking_price;
							price = parseFloat(price);
						}

						var total_fees = 0;
						if (q > 0) {
							total_fees = q * val.fees_percentage;
							total_fees = parseFloat(total_fees);
						}
						var price_total_fees = price + total_fees;
						var total_vat = 0;
						if (q > 0) {
							total_vat = price_total_fees * inputs.vat_percentage / 100;
							total_vat = parseFloat(total_vat);
						}
						var total_price = 0;
						if (q > 0) {
							total_price = price + total_fees + total_vat;
							total_price = parseFloat(total_price);
						}
						price = price.toFixed(2);
						total_fees = total_fees.toFixed(2);
						total_vat = total_vat.toFixed(2);
						total_price = total_price.toFixed(2);
						const updatedtik = {
							...val,
							price: price,
							qty: q,
							total_fees: total_fees,
							total_vat: total_vat,
							total_price: total_price
						};
						return updatedtik;
					}
				}
			}
			return val;
		});
		setTicket(updatedTicket);
	};
	const handleDecrease = (event, ticket_id) => {
		const updatedTicket = ticket.map((val) => {
			if (val.id === ticket_id) {
				if (val.qty > 0) {
					var q = val.qty - 1;
					var price = parseFloat(val.booking_price);
					if (q > 0) {
						price = q * val.booking_price;
						price = parseFloat(price);
					}

					var total_fees = 0;
					if (q > 0) {
						total_fees = q * val.fees_percentage;
						total_fees = parseFloat(total_fees);
					}
					var price_total_fees = price + total_fees;
					var total_vat = 0;
					if (q > 0) {
						total_vat = price_total_fees * inputs.vat_percentage / 100;
						total_vat = parseFloat(total_vat);
					}
					var total_price = 0;
					if (q > 0) {
						total_price = price + total_fees + total_vat;
						total_price = parseFloat(total_price);
					}
					price = price.toFixed(2);
					total_fees = total_fees.toFixed(2);
					total_vat = total_vat.toFixed(2);
					total_price = total_price.toFixed(2);
					const updatedtik = {
						...val,
						price: price,
						qty: q,
						total_fees: total_fees,
						total_vat: total_vat,
						total_price: total_price
					};
					return updatedtik;
				}
			}
			return val;
		});
		setTicket(updatedTicket);
	}
	const handleManualInputMo = (dialCode, numberWithoutCode, ticket_id, no) => {
		const lbl1 = 'country_code';
		const lbl2 = 'phone_number';
		var dialCode1 = '+' + dialCode;
		const updatedMember = member.map((val) => {
			if (val.ticket_id === ticket_id && val.no === no) {
				return {
					...val,
					[lbl1]: dialCode1,
					[lbl2]: numberWithoutCode
				};
			}
			return val;
		});

		setMember(updatedMember);
	}
	const handleManualInput = (event, ticket_id, no) => {
		var lbl1 = event.target.name;
		var lbl_val = event.target.value;

		if (lbl1 === "phone_number" && !/^\d*$/.test(lbl_val)) {
			return; // Skip update if value contains non-digits
		}

		const updatedMember = member.map((val) => {
			if (val.ticket_id === ticket_id && val.no === no) {
				const updatedtik = {
					...val,
					[lbl1]: lbl_val
				};
				return updatedtik;
			}
			return val;
		});
		setMember(updatedMember);
	};


	const handleSelection = (event, ticket_id, ticket_no, question_id, option_id, type) => {
		if (type === 'multiple_choice') {
			const updatedMembers = member.map((val) => {
				if (val.ticket_id === ticket_id && val.no === ticket_no) {
					return {
						...val,
						question: val.question.map((subq) => {
							if (subq.id === question_id) {
								return { ...subq, option_val: option_id };
							}
							return subq;
						}),
					};
				}
				return val;
			});

			setMember(updatedMembers);

		} else if (type === 'text') {
			var lbl_val = event.target.value;
			const updatedMembers = member.map((val) => {
				if (val.ticket_id === ticket_id && val.no === ticket_no) {
					return {
						...val,
						question: val.question.map((subq) => {
							if (subq.id === question_id) {
								return { ...subq, answer_text: lbl_val };
							}
							return subq;
						}),
					};
				}
				return val;
			});
			setMember(updatedMembers);
		}
	};

	const [activePopup, setActivePopup] = useState(null);
	const [previousPopup, setPreviousPopup] = useState(null);
	const handleOpen1 = (popup) => {

		setPreviousPopup(activePopup); // Save current popup before opening new
		setActivePopup(popup);

	}
	const handleOpen2 = (popup) => {
		setLoading(true);
		var chk = 0;
		ticket.forEach((val) => {
			if (val.qty > 0) {
				chk++;
			}
		});
		if (chk > 0) {
			const allNewTicket = [];
			ticket.forEach((val) => {
				if (val.qty > 0) {
					const newTicket = {
						ticket_id: val.id,
						price: val.booking_price,
						qty: val.qty,
					};
					allNewTicket.push(newTicket);
				}
			});


			let unq_id = localStorage.getItem('device_id');
			let formData = new FormData();
			formData.append('event_id', inputs.event_id);
			formData.append('unq_id', unq_id);
			formData.append('tickets', JSON.stringify(allNewTicket));
			API.post('check_temp_order_for_web', formData)
				.then(response => {
					if (response.data.status === false) {
						setLoading(false);
						gettoastwarning('Something went wrong. Please try again later.', '');
					} else {
						setLoading(false);
						setPreviousPopup(activePopup); // Save current popup before opening new
						setActivePopup(popup);
						setMember([]);
						const allNewMembers = [];

						ticket.forEach((val) => {
							var a = 1;
							for (let i = 1; i <= val.qty; i++) {

								var pf = parseFloat(val.booking_price) + val.fees_percentage;

								var total_vat = pf * inputs.vat_percentage / 100;
								total_vat = parseFloat(total_vat);

								const newMember = {
									ticket_id: val.id,
									price: val.price,
									fees_percentage: val.fees_percentage,
									vat_percentage: inputs.vat_percentage,
									booking_price: val.booking_price,
									total_fees: val.fees_percentage,
									total_vat: total_vat,
									ticket_name: val.name,
									total_price: val.total_price,
									no: a,
									first_name: '',
									last_name: '',
									email: '',
									country_code: '',
									phone_number: '',
									age: '',
									question: question.map(innerItem => ({ ...innerItem, answer_text: "", option_val: 0 }))
								};
								allNewMembers.push(newMember);
								a++;
							}
						});
						setMember((prev) => [...prev, ...allNewMembers]);
					}
				}).catch(error => {
					setLoading(false);
					gettoastwarning('Something went wrong. Please try again later.', '');
				});

		} else {
			setLoading(false);
			gettoastwarning('Ticket is required.', '');
		}
	};
	const handleOpen3 = (popup) => {

		const validationErrors = validatemember(member);
		const isEmptyObject = (obj) => Object.keys(obj).length === 0;

		const noErrors = Object.values(validationErrors).every(
			(fieldGroup) =>
				Object.values(fieldGroup).every((ticketGroup) =>
					isEmptyObject(ticketGroup)
				)
		);
		setErrors({});
		setErrors(validationErrors);

		if (noErrors) {
			setLoading(true);

			let formData1 = new FormData();
			formData1.append('event_id', inputs.event_id);
			formData1.append('tickets', JSON.stringify(member));
			API.post('check_email_is_blocked', formData1)
				.then(response1 => {
					if (response1.data.status === false) {
						setLoading(false);
						gettoastwarning(response1.data.message, '');
					} else {
						let unq_id = localStorage.getItem('device_id');
						let formData = new FormData();
						formData.append('event_id', inputs.event_id);
						formData.append('unq_id', unq_id);
						API.post('check_order_is_valid_or_not_for_web', formData)
							.then(response => {
								if (response.data.status === false) {
									setLoading(false);
									var u_link = '/event-product/' + inputs.event_id;
									gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
								} else {
									if (question.length > 0) {
										setLoading(false);
										setPreviousPopup(activePopup); // Save current popup before opening new
										setActivePopup(popup);
									} else {
										setLoading(false);
										navigate("/check-out", { state: { member, ticket, inputs } });
									}

								}
							}).catch(error => {
								setLoading(false);
								gettoastwarning('Something went wrong. Please try again later.', '');
							});
					}
				}).catch(error => {
					setLoading(false);
					gettoastwarning('Something went wrong. Please try again later.', '');
				});


		}
	}
	const handleOpen4 = (popup) => {
		setPreviousPopup(activePopup); // Save current popup before opening new
		setActivePopup(popup);

	}
	const handleBack = () => {
		setActivePopup(previousPopup); // Restore previous popup
		setPreviousPopup(null); // Clear previous state after going back
	};

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		document.title = `Event Detail | Your Friend My Friend`;
		document.getElementById("bodywrap").className = "products ano-pro";
		let device_id = localStorage.getItem('device_id');
		if (!device_id) {
			device_id = uuidv4();
			localStorage.setItem('device_id', device_id);
		}
		/* Start get store data */
		let formData = new FormData();
		formData.append('id', id);
		API.post('event_detail', formData)
			.then(response => {
				setLoading(false);
				if (response.data.status === false) {
					window.location.href = "/upcoming-events";
				} else {
					if(response.data.data.is_event_private===1){
					  	setShowbook(true);
						setShowdetails(false);
					}

					var tax_type='VAT';
					if(response.data.data.tax_type!=='')
					{
						tax_type=response.data.data.tax_type;
					}
					var symbol='\u20ac';
					if(response.data.data.symbol!=='')
					{
						symbol=response.data.data.symbol;
					}
					var currency='eur';
					if(response.data.data.currency!=='')
					{
						currency=response.data.data.currency;
					}

					setInputs({
						event_id: response.data.data.id,
						event_title: response.data.data.event_title,
						category_name: response.data.data.category_name,
						location_name: response.data.data.location_name,
						event_address: response.data.data.event_address,
						event_image: response.data.data.event_image,
						event_header_image: response.data.data.event_header_image,
						desktop_image: response.data.data.desktop_image,
						date: response.data.data.date,
						day: response.data.data.day,
						month: response.data.data.month,
						event_date: response.data.data.event_date,
						event_start_time: response.data.data.event_start_time,
						event_end_time: response.data.data.event_end_time,
						short_description: response.data.data.short_description,
						about_event: response.data.data.about_event,
						tickets_type: response.data.data.tickets_type,
						tickets_price: response.data.data.tickets_price,
						total_tickets: response.data.data.total_tickets,
						vat_percentage: response.data.data.vat_percentage,
						sub_total: 0,
						total_fees: 0,
						total_vat: 0,
						grand_total: 0,
						age_start: response.data.data.age_start,
						age_end: response.data.data.age_end,
						is_event_waitlist:response.data.data.is_event_waitlist,
						tax_type:tax_type,
						symbol:symbol,
						currency:currency,
						is_free_event:response.data.data.is_free_event,
					});
					setGallery(response.data.data.gallery);
					setAgenda(response.data.data.agenda);
					setQuestion(response.data.data.question);
					setTags(response.data.data.tags);


					//const tempticketArr = response.data.data.ticket.map(item => ({ ...item,org_price: item.price,org_fees_percentage:item.fees_percentage,qty: 0, booking_price: item.price, total_fees: 0, total_vat: 0, total_price: 0 }))
					
					const tempticketArr = response.data.data.ticket.map((val) => {
						  var total_fees = 0;
						  var q=1; 
						  if (q > 0) { 
						  	
						  	total_fees = val.fees_percentage; 
						  }
						   var price_total_fees = parseFloat(val.price) + parseFloat(total_fees); 

						   var total_vat = 0; 
						   var vat_percentage=parseInt(response.data.data.vat_percentage);
						   if (q > 0) { 
						   	total_vat = parseFloat(price_total_fees) * vat_percentage / 100; 
						   	
						   	total_vat = parseFloat(total_vat); 
						   	total_vat=total_vat.toFixed(2);
						   }

						  return {
						    ...val,
						    org_price: val.price,
						    org_fees_percentage: val.fees_percentage,
						    org_vat:total_vat,
						    qty: 0,
						    booking_price: val.price,
						    total_fees: 0,
						    total_vat: 0,
						    total_price: 0,
						  };
						});

					setTicket(tempticketArr);
				}
			}).catch(error => {

			});
		/* End get store data */
			// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);


	const check_out = () => {
		const validationErrors = validatequestion(member);
		const isEmptyDeep = (obj) => {
			return Object.values(obj).every((nested) => {
				return Object.values(nested).every((inner) => {
					return Object.keys(inner).length === 0;
				});
			});
		};

		const noErrors = isEmptyDeep(validationErrors.question);
		setErrors({});
		setErrors(validationErrors);

		if (noErrors) {
			setLoading(true);
			let unq_id = localStorage.getItem('device_id');
			let formData = new FormData();
			formData.append('event_id', inputs.event_id);
			formData.append('unq_id', unq_id);
			API.post('check_order_is_valid_or_not_for_web', formData)
				.then(response => {
					if (response.data.status === false) {
						setLoading(false);
						var u_link = '/event-product/' + inputs.event_id;
						gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
					} else {
						setLoading(false);
						navigate("/check-out", { state: { member, ticket, inputs } });
					}
				}).catch(error => {
					setLoading(false);
					gettoastwarning('Something went wrong. Please try again later.', '');
				});
		}
	}
	const join_waitlist = () => {
		const validationErrors = validatejoinwaitlist(inputsj);
		const noErrors = Object.keys(validationErrors).length === 0;
		setErrors({});
		setErrors(validationErrors);
		if (noErrors) {
			let formData = new FormData();
			formData.append('event_id', inputs.event_id);
			formData.append('email', inputsj.email);
			formData.append('first_name', inputsj.first_name);
			formData.append('last_name', inputsj.last_name);
			formData.append('mobile_number', inputsj.phone_number);
			formData.append('age', inputsj.age);
			formData.append('gender', inputsj.gender);
			API.post('join_waitlist_web', formData)
				.then(response => {
					setLoading(false);
					if (response.data.status === false) {
						gettoastwarning(response.data.message, '');
					} else {
						setInputsj({ first_name: '', last_name: '', email: '', phone_number: '',age:'',gender:'' });
						setActivePopup('first');
						gettoastsuccess(response.data.message, '');

					}
				}).catch(error => {

				});
		}
	}
	/* Start Value set */
	const handleInputChange = (event) => {
		event.persist();
		setInputsj(inputsj => ({ ...inputsj, [event.target.name]: event.target.value }));
	}
	const LeaveUrl1 = () => {
		setLoading(false);
		setShowTwo(false);
		setActivePopup('second');
	}
	const LeaveUrl = () => {
		setLoading(true);
		let unq_id = localStorage.getItem('device_id');
		let formData = new FormData();
		formData.append('event_id', inputs.event_id);
		formData.append('unq_id', unq_id);
		API.post('leave_check_out_for_web', formData)
			.then(response => {
				if (response.data.status === false) {
					setLoading(false);
					var u_link = '/event-product/' + inputs.event_id;
					gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
				} else {
					setLoading(false);
					setShowFirst(false);
					setActivePopup('first');
					//window.location.href = '/event-product/'+inputs.event_id;
					//navigate('/event-product/'+inputs.event_id);
				}
			}).catch(error => {
				setLoading(false);
				gettoastwarning('Something went wrong. Please try again later.', '');
			});
	}

const handleInputChangeb = (event) => {
    event.persist();
    setInputsb(inputsb => ({ ...inputsb, [event.target.name]: event.target.value }));
}
const check_event_password = () => {
    const validationErrors = validatecheckeventpassword(inputsb);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors({});
    setErrors(validationErrors);
    if (noErrors) {
    	setLoading(true);
      let formData = new FormData();
      formData.append('event_id', id);
      formData.append('password', inputsb.password);
      API.post('check_event_password_is_correct', formData)
        .then(response => {
          setLoading(false);
          if (response.data.status === false) {
            gettoastwarning(response.data.message, '');
          } else {
          	setShowbook(false);
              setShowdetails(true);
          }
        }).catch(error => {

        });
    }
}


	return (
		<>
		 {showdetails && (
		 	<>
			<Header />

			<div className="hello-worldss d-flex justify-content-center align-items-center">
				{/* Desktop Image */}
				<img
					src={inputs.event_header_image}
					alt="QR Code"
					className="img-fluid d-none d-md-block pro-img-det"
				/>

				{/* Mobile Image */}
				<img
					src={inputs.desktop_image}
					alt="QR Code"
					className="img-fluid d-block d-md-none pohchaki"
				/>
			</div>

			<div className="container-fluid wiklo">
				<div className="row">
					{/* Left Section - Event Details */}
					<div className="col-lg-7 wiklo-left">
						<div className="spp">{inputs.category_name}</div>
						<h2>{inputs.event_title}</h2>
						<div className="d-flex gap-2 mb-3 mt-3 flex-wrap">
							<h4>{inputs.event_date}</h4>
							{(() => {
								if (inputs.age_start === '' && inputs.age_end === '') {

								} else if (inputs.age_start !== '' && inputs.age_end === '') {
									return (<h5>Age {inputs.age_start}+</h5>)
								} else if (inputs.age_start === '' && inputs.age_end !== '') {
									return (<h5>Age {inputs.age_end}+</h5>)
								} else if (inputs.age_start !== '' && inputs.age_end !== '') {
									return (<h5>Ages {inputs.age_start} - {inputs.age_end}</h5>)
								}
							})()}
							{(() => {
								if (inputs.event_address !== '') {
									return (<h6>{inputs.event_address}</h6>)
								}
							})()}
							{tags.map((val1, index1) => {
								return (
									<h5>{val1}</h5>
								)
							})}
						</div>
						<div className="event-text-box" dangerouslySetInnerHTML={{ __html: inputs.about_event }} />
						{gallery.length > 0 && (
							<div className="real-connection ner-real ps-0 pe-0">
								<div className="row">
									{gallery.length > 1 ? (
										<>
											<div className="col-md-12 d-flex justify-content-between align-items-center mb-2">
												<div className="slidees ols">
													<h2>Event Gallery</h2>
												</div>
												<div className="d-none d-md-flex justify-content-start">
													<button
														className="btn"
														onClick={() => sliderRef.current.slickPrev()}
													>
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-left.png"
															}
															className="img-fluid arrow-image arrow-image-1"
															alt="Previous"
														/>
													</button>
													<button
														className="btn"
														onClick={() => sliderRef.current.slickNext()}
													>
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-right.png"
															}
															className="img-fluid arrow-image arrow-image-1"
															alt="Next"
														/>
													</button>
												</div>
											</div>

											<div className="col-md-12">
												<div>
													{gallery.length > 0 && (
														<Slider ref={sliderRef} {...settings}>

															{gallery && gallery.map((val, i) => {
																return (
																	<div key={i} className={`custom-slide pt-3 ${i === gallery.length - 1 ? 'last-slide' : ''}`}>
																		<img
																			src={val.image}
																			className="img-fluid respo"
																			alt={`Slide ${i}`}
																			style={{ width: "100%", height: "400px", borderRadius: 24, objectFit: "cover" }}
																			onError={(e) => (e.target.style.display = "none")}
																		/>
																	</div>
																)
															})}
														</Slider>
													)}
												</div>
											</div>
										</>
									) : (
										<><div>
											<div className="col-md-12 d-flex justify-content-between align-items-center mb-2">
												<div className="slidees ols">
													<h2>Event Gallery</h2>
												</div>

											</div>
											{gallery && gallery.map((val, i) => {
												return (
													<div key={i} className={`custom-slide pt-3 ${i === gallery.length - 1 ? 'last-slide' : ''}`}>
														<img
															src={val.image}
															className="img-fluid respo"
															alt={`Slide ${i}`}
															style={{ width: "100%", height: "400px", borderRadius: 24, objectFit: "cover" }}
															onError={(e) => (e.target.style.display = "none")}
														/>
													</div>
												)
											})}</div></>

									)}
									{gallery.length > 1 ? (
										<>
											<div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
												<button
													className="btn vichi"
													onClick={() => sliderRef.current.slickPrev()}
												>
													<div className="arrow-container">
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-left.png"
															}
															className="img-fluid arrow-image arrow-image-1"
															alt="Previous"
														/>
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-left-hover.png"
															}
															className="img-fluid arrow-image arrow-image-2"
															alt="Previous Hover"
														/>
													</div>
												</button>
												<button
													className="btn vichi"
													onClick={() => sliderRef.current.slickNext()}
												>
													<div className="arrow-container">
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-right.png"
															}
															className="img-fluid arrow-image arrow-image-1"
															alt="Next"
														/>
														<img
															src={
																process.env.REACT_APP_BASE_URL +
																"assests/images/carousel-right-hover.png"
															}
															className="img-fluid arrow-image arrow-image-2"
															alt="Next Hover"
														/>
													</div>
												</button>
											</div>
										</>
									) : (
										<>
											<div>

											</div>
										</>
									)}
								</div>
							</div>
						)}

						{agenda.length > 0 && (
							<>
								<div className="acco-banner">Agenda</div>
								<div className="row">
									<div className="col-md-12">
										<Accordion defaultActiveKey={0}>
											{agenda && agenda.map((val, index) => {
												return (
													<Accordion.Item eventKey={index}>
														<Accordion.Header>
															<div className="d-flex flex-column">
																<div className="juy">{val.start_time} - {val.end_time}</div>
																<div className="juyyy">
																	{val.title}
																</div>
															</div>
														</Accordion.Header>
														<Accordion.Body>
															{val.description}
														</Accordion.Body>
													</Accordion.Item>
												)
											})}
										</Accordion>
									</div>
								</div>
							</>
						)}
					</div>

					<div className="col-lg-1"></div>

					{/* Right Section - Ticket Card */}
					<div className="col-lg-4 wiklo-right">
						<div className="card">
							<h2 className="mb-0">{inputs.event_title}</h2>
							<div className="prices d-flex justify-content-between">
								{/* Starting price <span className="aank">€{inputs.tickets_price}</span> */}
							</div>
							<button className="btn w-100" onClick={() => handleOpen1("first")}>
								GET TICKETS
							</button>
							{/*{inputs.total_tickets > 0 ? <button className="btn w-100" onClick={() => handleOpen1("first")}>
								GET TICKETS
							</button> : <button className="btn w-100" onClick={() => handleOpen4("fourth")}>
								Join waitlist
							</button>}*/}
							{/* <p className="d-none d-sm-block">
                Select more options on next step
              </p> */}
						</div>
					</div>
				</div>
			</div>

			{activePopup === "first" && (
				<Modal
					show={activePopup === "first"}
					onHide={() => setActivePopup(null)}
					centered
					size="lg"
				>
					<div className="tickee">
						<Modal.Header closeButton>
							<Modal.Title>
								<button onClick={handleBack}>
									<img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
								</button>
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="logo">{inputs.category_name}</div>
							<h3>{inputs.event_title}</h3>
							<div className="d-flex flex-wrap gap-2 mb-3">
								<h4>{inputs.event_date}</h4>
								{(() => {
									if (inputs.event_start_time === '' && inputs.event_end_time === '') {

									} else if (inputs.event_start_time !== '' && inputs.event_end_time === '') {
										return (<h5>{inputs.event_start_time}</h5>)
									} else if (inputs.event_start_time === '' && inputs.event_end_time !== '') {
										return (<h5>{inputs.event_end_time}</h5>)
									} else if (inputs.event_start_time !== '' && inputs.event_end_time !== '') {
										return (<h5>{inputs.event_start_time} - {inputs.event_end_time}</h5>)
									}
								})()}
								<h6>{inputs.event_address}</h6>
							</div>
							{/* Ticket Selection */}
							{ticket && ticket.map((val, index) => {
								return (
									<div className="count mb-3 d-flex justify-content-between align-items-start">
										<div>
											<span>{val.name}</span>
											<p>
											   {inputs.symbol}{(
											        Number(val.org_price) +
											        Number(val.org_fees_percentage) +
											        Number(val.org_vat)
											      ).toFixed(2)}{" "}
											  <span className="cou-sp">
											    (Includes {inputs.symbol}{val.org_fees_percentage} Booking Fee + {inputs.symbol}{val.org_vat} {inputs.tax_type})
											  </span>
											</p>
										</div>
										<div className="d-flex align-items-center">
											{val.total_tickets > 0 ? (
												<>
													<Button
														className="minus"
														onClick={(event) => handleDecrease(event, val.id)}
													>
														<Minus color="#1C2337" size={15} />
													</Button>

													<span className="mx-2 num">{val.qty}</span>

													<Button
														className="plus"
														onClick={(event) => handleIncrease(event, val.id)}
													>
														<Plus color="#FFFFFF" size={15} />
													</Button>
												</>
											) : (
											<>
												<button type="button" className="btn btn-danger">
													Sold Out
												</button>

												{inputs.is_event_waitlist === 1 && (
											        <div className="join-wlist-box-common text-center ms-2">
											          <Button onClick={() => handleOpen4("fourth")}>
											            Join waitlist
											          </Button>
											        </div>
											      )}
											  </>
											)}

										</div>
									</div>
								)
							})}
							
							<div className="subtotal mt-2 mb-2">
						      Sub Total: <b>{inputs.symbol}
						      {ticket.reduce(
						        (sum, item) =>
						          sum + parseFloat(item.total_price),
						        0
						      )} </b>
						    </div>


							{/* Promo Code */}
							{/*<label>Promo Code </label>
							<div className="mt-2 d-flex align-items-center justify-content-center areas">
								<input
									type="text"
									className="form-control"
									placeholder="Enter Promo Code"
								/>
								<Button type="submit" className="p-0 mt-1">
									Apply
								</Button>
							</div>*/}
						</Modal.Body>
						<Modal.Footer>
							<Button
								type="submit"
								className="w-100"
								onClick={() => handleOpen2("second")}
							>
								CONTINUE
							</Button>
						</Modal.Footer>
					</div>
				</Modal>
			)}

			{activePopup === "second" && (
				<Modal
					show={activePopup === "second"}
					onHide={() => setActivePopup(null)}
					size="lg"
					centered
				>
					<div className="speed">
						<Modal.Header>
							<Modal.Title>
								<button onClick={() => { LeaveUrl(); }}>
									<img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
								</button>
								<button className="custom-close" onClick={handleShowDirectLeavePopup}>
									<img
										src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
										alt="Close"
										style={{ width: "18px" }}
									/>
								</button>
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							{/* Male speed dating ticket 1 (Autofill Enabled/Manual Entry) */}
							{member && member.map((val, index) => {
								return (
									<div className="mb-4">
										<h5 className="mb-2">{val.ticket_name} </h5>
										<Form>
											<Row className="mb-3 g-3">
												<Col xs={6} sm={6} md={6} lg={6} xl={6}>
													<Form.Label>First Name</Form.Label>
													<Form.Control
														type="text"
														name="first_name"
														placeholder="First name"
														value={val.first_name}
														onChange={(event) => handleManualInput(event, val.ticket_id, val.no)}
													/>
													{errors.first_name?.[val.ticket_id]?.[val.no] && (
														<p className="text-danger">{errors.first_name[val.ticket_id][val.no]}</p>
													)}
												</Col>
												<Col xs={6} sm={6} md={6} lg={6} xl={6}>
													<Form.Label>Last Name</Form.Label>
													<Form.Control
														type="text"
														name="last_name"
														placeholder="Last name"
														value={val.last_name}
														onChange={(event) => handleManualInput(event, val.ticket_id, val.no)}
													/>
													{errors.last_name?.[val.ticket_id]?.[val.no] && (
														<p className="text-danger">{errors.last_name[val.ticket_id][val.no]}</p>
													)}
												</Col>
											</Row>
											<Row className="mb-3">
												<Col md={12}>
													<Form.Label>Email</Form.Label>
													<Form.Control
														type="text"
														name="email"
														placeholder="Email"
														value={val.email}
														onChange={(event) => handleManualInput(event, val.ticket_id, val.no)}
													/>
													{errors.email?.[val.ticket_id]?.[val.no] && (
														<p className="text-danger">{errors.email[val.ticket_id][val.no]}</p>
													)}
												</Col>
											</Row>
											<Row className="mb-4 g-3">
												<Col xs={12} sm={6} md={6} lg={6} xl={6}>
													<Form.Label>Phone Number </Form.Label>
													<PhoneInput
														country={'ie'}
														value={val.country_code + val.phone_number} // or however you're setting the value
														onChange={(value, countryData = {}) => {
															const dialCode = countryData.dialCode || '';

															// Remove dial code from the value (with '+' just to be safe)
															let numberWithoutCode = value;

															if (dialCode) {
																const cleanDial = `+${dialCode}`;
																if (value.startsWith(cleanDial)) {
																	numberWithoutCode = value.slice(cleanDial.length);
																} else if (value.startsWith(dialCode)) {
																	numberWithoutCode = value.slice(dialCode.length);
																}
															}

															handleManualInputMo(dialCode, numberWithoutCode, val.ticket_id, val.no);
														}}
													/>
													{errors.phone_number?.[val.ticket_id]?.[val.no] && (
														<p className="text-danger">{errors.phone_number[val.ticket_id][val.no]}</p>
													)}
												</Col>

												<Col xs={12} sm={6} md={6} lg={6} xl={6}>
													<Form.Label>Age</Form.Label>
													<Form.Control
														type="number"
														name="age"
														placeholder="Your Age"
														value={val.age}
														min="1"
														onChange={(event) => handleManualInput(event, val.ticket_id, val.no)}
													/>
													{errors.age?.[val.ticket_id]?.[val.no] && (
														<p className="text-danger">{errors.age[val.ticket_id][val.no]}</p>
													)}
												</Col>
											</Row>
										</Form>
									</div>
								)
							})}
						</Modal.Body>
						<Modal.Footer>
							<Button
								variant="primary"
								className="w-100"
								onClick={() => handleOpen3("third")}
							>
								Continue
							</Button>
						</Modal.Footer>
					</div>
				</Modal>
			)}

			{activePopup === "third" && (
				<Modal
					show={activePopup === "third"}
					onHide={() => setActivePopup(null)}
					size="lg"
					centered
				>
					<div className="provide">
						<Modal.Header>
							<Modal.Title>
								<button onClick={() => { LeaveUrl1(); }}>
									<img src={process.env.REACT_APP_BASE_URL + 'assests/images/back.png'} alt="Back" />
								</button>
								<button className="custom-close" onClick={handleShowDirectLeavePopup}>
									<img
										src={process.env.REACT_APP_BASE_URL + 'assests/images/clo-ti.svg'}
										alt="Close"
										style={{ width: "18px" }}
									/>
								</button>
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="titling">
								{member.map((ticket, index) => (
									<div key={index} className="mb-4 boxes">
										<h5>{ticket.ticket_name}</h5>
										{ticket.question && ticket.question.map((val1, index1) => {
											return (
												<Form>
													{(() => {
														if (val1.type === 'multiple_choice') {
															return (
																<Form.Group className="mb-3">
																	<Form.Label>
																		{val1.question_text}
																	</Form.Label>
																	{val1.options && val1.options.map((val2, index2) => {
																		return (
																			<div
																				key={val2.id}
																				className={`d-flex justify-content-between align-items-center chekes ${val2.id === val1.option_val
																						? "selected"
																						: ""
																					}`}
																				onClick={(event) => handleSelection(event, ticket.ticket_id, ticket.no, val1.id, val2.id, 'multiple_choice')}
																			>
																				<span>{val2.option_text}</span>
																				<Form.Check
																					type="radio"
																					name={ticket}
																					checked={val2.id === val1.option_val}
																					onClick={(event) => handleSelection(event, ticket.ticket_id, ticket.no, val1.id, val2.id, 'multiple_choice')}
																				/>
																			</div>
																		)
																	})}
																</Form.Group>
															)
														} else if (val1.type === 'text') {
															return (
																<Form.Group className="mb-3">
																	<Form.Label>
																		{val1.question_text}
																	</Form.Label>
																	<Form.Control
																		as="textarea"
																		rows={6}
																		placeholder="Type answer"
																		value={val1.answer_text}
																		onChange={(event) => handleSelection(event, ticket.ticket_id, ticket.no, val1.id, 0, 'text')}
																	/>
																</Form.Group>
															)
														}
													})()}
													{errors.question?.[ticket.ticket_id]?.[ticket.no]?.[val1.id] && (
														<p className="text-danger">
															{errors.question[ticket.ticket_id][ticket.no][val1.id]}
														</p>
													)}

												</Form>
											)
										})}
									</div>
								))}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<Button variant="dark" className="w-100" onClick={() => check_out()}>
								CONTINUE 
							</Button>
						</Modal.Footer>
					</div>
				</Modal>
			)}

			{activePopup === "fourth" && (
				<Modal
					show={activePopup === "fourth"}
					onHide={() => setActivePopup(null)}
					size="lg"
					centered
				>
					<div className="providess">
						<Modal.Header closeButton>
						</Modal.Header>
						<Modal.Body>
							<form>
								<div className="row">
									<div className="col-md-6">
										<label htmlFor="first-name" className="form-label">
											First name *
										</label>
										<input
											type="text"
											id="first-name"
											name="first_name"
											className="form-control mb-3"
											placeholder="First Name"
											onChange={handleInputChange}
										/>
										{errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
									</div>
									<div className="col-md-6">
										<label htmlFor="last-name" className="form-label">
											Last Name *
										</label>
										<input
											type="text"
											id="last-name"
											name="last_name"
											className="form-control mb-3"
											placeholder="Last Name"
											onChange={handleInputChange}
										/>
										{errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
									</div>
								</div>

								<div className="col-md-12">
									<label htmlFor="email" className="form-label">
										Email *
									</label>
									<input
										type="text"
										id="email"
										name="email"
										className="form-control mb-3"
										placeholder="Email"
										onChange={handleInputChange}
									/>
									{errors.email && (<p className="text-danger">{errors.email}</p>)}
								</div>
								<div className="row">
									<div className="col-md-6">
										<label htmlFor="age" className="form-label">
											Age *
										</label>
										<Form.Control
											type="number"
											name="age"
											placeholder="Your Age"
											min="1"
											onChange={handleInputChange}
										/>
										{errors.age && (<p className="text-danger">{errors.age}</p>)}
									</div>
									<div className="col-md-6">
										<label htmlFor="last-name" className="form-label">
											Gender *
										</label>
										<div key="gender1" className="mb-3 rad-gender">
												<Form.Check 
													inline
										            type="radio"
										            id="gender1"
										            name="gender"
										            label="Male"
										            value="Male"
										            onChange={handleInputChange}
										          />
										          <Form.Check 
										          	inline
										            type="radio"
										            id="gender2"
										            name="gender"
										            label="Female"
										            value="Female"
										            onChange={handleInputChange}
										          />
										          <Form.Check
										          	inline 
										            type="radio"
										            id="gender3"
										            name="gender"
										            label="Non-binary"
										            value="Non-binary"
										            onChange={handleInputChange}
										          />
										</div>
										
										{errors.gender && (<p className="text-danger">{errors.gender}</p>)}
									</div>
								</div>
								<div className="col-md-12">
									<label htmlFor="phone-number" className="form-label">
										Phone number 
									</label>
									<input
										type="text"
										id="phone-number"
										name="phone_number"
										className="form-control mb-3"
										placeholder="Phone number"
										onChange={handleInputChange}
									/>
									{errors.phone_number && (<p className="text-danger">{errors.phone_number}</p>)}
								</div>

								<Button type="button" className="btn w-100 mt-4" onClick={() => join_waitlist()}>
									Submit
								</Button>
							</form>
						</Modal.Body>
					</div>
				</Modal>
			)}

			{/* Leave POP Step View */}
			<Modal
				show={showFirst}
				onHide={() => setShowFirst(false)}
				centered
				size="lg"
				className="newyesrt"
			>
				<div className="leav">
					<div className="close-btn" onClick={() => setShowFirst(false)}>
						<X size={30} />
					</div>
					<Modal.Body className="text-center p-4">
						<h4>Leave checkout?</h4>
						<p>
							Are you sure you want to leave checkout? <br></br>
							The item you’ve selected may not be available later
						</p>
						<div className="d-flex justify-content-center gap-2 noyle">
							<Button type="button" className="w-100 st" onClick={() => setShowFirst(false)}>STAY</Button>
							<Button type="button" className="w-100 le" onClick={() => { LeaveUrl(); }}>
								LEAVE
							</Button>
						</div>
					</Modal.Body>
				</div>
			</Modal>


			{/* Leave POP Step View */}
			<Modal
				show={showTwo}
				onHide={() => setShowTwo(false)}
				centered
				size="lg"
				className="newyesrt"
			>
				<div className="leav">
					<div className="close-btn" onClick={() => setShowTwo(false)}>
						<X size={30} />
					</div>
					<Modal.Body className="text-center p-4">
						<h4>Leave checkout?</h4>
						<p>
							Are you sure you want to leave checkout? <br></br>
							The item you’ve selected may not be available later
						</p>
						<div className="d-flex justify-content-center gap-2 noyle">
							<Button type="button" className="w-100 st" onClick={() => setShowTwo(false)}>STAY</Button>
							<Button type="button" className="w-100 le" onClick={() => { LeaveUrl1(); }}>
								LEAVE
							</Button>
						</div>
					</Modal.Body>
				</div>
			</Modal>

			<Modal
				show={showThree}
				onHide={() => setShowThree(false)}
				centered
				size="lg"
				className="newyesrt"
			>
				<div className="leav">
					<div className="close-btn" onClick={() => setShowThree(false)}>
						<X size={30} />
					</div>
					<Modal.Body className="text-center p-4">
						<h4>Leave checkout?</h4>
						<p>
							Are you sure you want to leave checkout? <br />
							The item you’ve selected may not be available later
						</p>
						<div className="d-flex justify-content-center gap-2 noyle">
							<Button type="button" className="w-100 st" onClick={() => setShowThree(false)}>
								STAY
							</Button>
							<Button type="button" className="w-100 le" onClick={LeaveUrlDirect}>
								LEAVE
							</Button>
						</div>
					</Modal.Body>
				</div>
			</Modal>



			

			{loading && (
				<div className="loadingClass">
					<img src={loader} alt="loader" />
				</div>
			)}
			<Footer />
		</>)}
	{/* Book Tickets */}
      <Modal
        show={showbook}
        onHide={() => setShowbook(false)}
        backdrop="static"
        centered
        size="md"
        className="newyesrt"
      >
        <div className="leav p-5">
          <div className="close-btn" onClick={() => navigate("/upcoming-events")}>
            <X size={30} />
          </div>

          <Modal.Body className="text-center p-4">
            
            {/* Password Field */}
            <Row className="mb-3 g-3">
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Label className="w-100 text-start">Password</Form.Label>
                  <Form.Control
                    type="text"
                    name="password"
                    placeholder="Password"
                    value={inputsb.password}
                    onChange={handleInputChangeb}
                  />
                  {errors.password && (<p className="text-danger mb-0 text-start">{errors.password}</p>)}
                </Col>
            </Row>

            <div className="d-flex justify-content-center gap-2 noyle mt-3">
              <Button type="button" className="w-100 st" onClick={() => check_event_password()}>
                SUBMIT
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
		</>
	);
};

export default EventProductPage;
